import { forwardRef } from 'react';
import { Button as AntButton, Tooltip } from 'antd';
import { DisabledButtonWrapper } from 'components/common/styled';

const Button = forwardRef((props, ref) => {
  if (props.tooltip) {
    return (
      <Tooltip title={props.tooltip}>
        <DisabledButtonWrapper>
          <AntButton {...props} ref={ref} />
        </DisabledButtonWrapper>
      </Tooltip>
    );
  }

  return <AntButton {...props} ref={ref} />;
});

Button.defaultProps = {
  'data-testid': 'button',
};

export default Button;
